
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.813 6.705h1.443v6.607c0 .086.07.157.156.157h1.172c.086 0 .156-.07.156-.157V6.705h1.447c.131 0 .204-.15.123-.252l-2.187-2.77a.155.155 0 00-.191-.044.156.156 0 00-.055.044L7.689 6.451a.157.157 0 00.123.254zm9.335 6.021h-1.171a.157.157 0 00-.157.157v3.008H4.18v-3.008a.157.157 0 00-.157-.156H2.852a.157.157 0 00-.157.156v3.867c0 .346.28.625.625.625h13.36c.345 0 .625-.28.625-.625v-3.867a.157.157 0 00-.157-.156z","fill":"#000"}})])
          )
        }
      }
    